export default "__VITE_ASSET__5111d11d__"